import { Link } from 'react-router-dom';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

const placeholderLabels = [
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
  'Coming Soon',
  'Design in Progress',
  'Future Bulldogs Tee',
];

const placeholderColors = [
  ['#6B0000', '#FFFFFF', '#808080'],
  ['#F5F5DC', '#6B0000', '#111827'],
  ['#808080', '#FFFFFF', '#6B0000'],
  ['#FFFFFF', '#6B0000', '#808080'],
  ['#6B0000', '#111827', '#FFFFFF'],
  ['#FFFFFF', '#808080', '#6B0000'],
];

const placeholderImages = [
  'https://public.readdy.ai/ai/img_res/7a6f9c70b49a7d85d4f6b27a705e5490.jpg',
  'https://readdy.ai/api/search-image?query=plain%20white%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_shop_02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20gray%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_shop_03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20cream%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_shop_04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20black%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_shop_05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=plain%20maroon%20long%20sleeve%20t-shirt%20mockup%20ghost%20mannequin%20on%20pure%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20cotton%20fabric%20texture&width=600&height=750&seq=ph_shop_06&orientation=portrait',
];

export default function ShopPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Header */}
      <section className="relative bg-gradient-to-br from-[#6B0000] via-[#8B0000] to-[#660000] pt-32 pb-20 px-6">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-white/20 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            Full Collection
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-4">
            Shop Bulldogs Tees
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Browse our complete collection of Mississippi State inspired shirts. All printed locally in Starkville.
          </p>
        </div>
      </section>

      {/* Coming Soon Notice */}
      <section className="py-8 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 bg-[#6B0000]/8 border border-[#6B0000]/20 rounded-xl px-6 py-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#6B0000]/10 rounded-full shrink-0">
              <i className="ri-time-line text-[#6B0000] text-xl"></i>
            </div>
            <div>
              <p className="text-sm font-bold text-[#6B0000]">Merchandise Coming Soon</p>
              <p className="text-sm text-gray-600">Our Bulldogs tee collection is being finalized. In the meantime, you can design your own custom shirt in our studio!</p>
            </div>
            <Link
              to="/customize"
              className="ml-auto px-5 py-2.5 bg-[#6B0000] text-white text-sm font-bold rounded-lg hover:bg-[#550000] transition-colors whitespace-nowrap cursor-pointer"
            >
              Design Your Shirt
            </Link>
          </div>
        </div>
      </section>

      {/* Placeholder Product Grid */}
      <section className="py-8 px-6 pb-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-product-shop>
            {placeholderLabels.map((label, index) => (
              <PlaceholderCard
                key={index}
                label={label}
                image={placeholderImages[index]}
                colors={placeholderColors[index]}
              />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function PlaceholderCard({
  label,
  image,
  colors,
}: {
  label: string;
  image: string;
  colors: string[];
}) {
  return (
    <div className="group bg-white rounded-xl overflow-hidden border border-gray-200 opacity-60 select-none">
      {/* Image Container */}
      <div className="relative aspect-[4/5] bg-gray-100 overflow-hidden">
        <img
          src={image}
          alt="Coming soon product"
          className="w-full h-full object-contain blur-[2px] scale-105"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-white/40 flex flex-col items-center justify-center gap-2">
          <div className="w-10 h-10 flex items-center justify-center bg-white/80 rounded-full shadow">
            <i className="ri-lock-line text-[#6B0000] text-lg"></i>
          </div>
          <span className="px-4 py-1.5 bg-[#6B0000] text-white text-xs font-bold rounded-full shadow-md tracking-wide">
            {label}
          </span>
        </div>
      </div>

      {/* Product Info Skeleton */}
      <div className="p-4">
        {/* Name skeleton */}
        <div className="h-4 bg-gray-200 rounded-full w-3/4 mb-3"></div>

        {/* Rating skeleton */}
        <div className="flex items-center gap-1 mb-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-4 h-4 bg-gray-200 rounded-full"></div>
          ))}
          <div className="h-3 bg-gray-200 rounded-full w-10 ml-1"></div>
        </div>

        {/* Color swatches */}
        <div className="flex items-center gap-1.5 mb-4">
          {colors.map((color, i) => (
            <div
              key={i}
              className="w-5 h-5 rounded-full border-2 border-gray-300"
              style={{ backgroundColor: color }}
            ></div>
          ))}
        </div>

        {/* Price skeleton */}
        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
          <div className="h-6 bg-gray-200 rounded-full w-16"></div>
          <div className="w-9 h-9 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
}
